/**
 * Created by neo on 22.09.21.
 */
import { makeAutoObservable } from 'mobx';
import { ProgramParams, createProgramParams } from './ProgramParams';

export type ProgramTemplateProgramParamsJson = ProgramParams & {
  equipmentLocked: boolean;
};

export type ProgramTemplateProgramParams = ProgramParams & {
  equipmentLocked: boolean;
  toJS(): ProgramTemplateProgramParamsJson;
};

export function createProgramTemplateProgramParams(json?: Partial<ProgramTemplateProgramParamsJson>): ProgramTemplateProgramParams {
  const base = createProgramParams(json);
  return makeAutoObservable({
    ...base,
    equipmentLocked: json?.equipmentLocked ?? false,

    toJS(): ProgramTemplateProgramParamsJson {
      return {
        ...base,
        equipmentLocked: this.equipmentLocked,
      };
    },
  });
}
